import React from 'react';

import { type ProfilecardProvider } from '@atlaskit/editor-common/provider-factory';

type RovoProfilecardProvider = { value?: ProfilecardProvider };
const initialState: RovoProfilecardProvider = {};

const rovoProfilecardProvider = React.createContext<RovoProfilecardProvider>(initialState);
export const RovoProfilecardProvider: React.Provider<RovoProfilecardProvider> =
	rovoProfilecardProvider.Provider;
export const useRovoProfilecardProvider = (): RovoProfilecardProvider =>
	React.useContext(rovoProfilecardProvider);
